import React, { useEffect, useState } from "react";

const ShowHomeScoreboard = ({object}) => {
  const [showLoader, setLoader] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 1500);
    // setLoader(false);
  }, []);
  return (
    <div className="w-100" style={{ position: "relative" }}>
      {showLoader && (
        <div
          id="loading1"
          className="loading1 loading1Outer"
          style={{ display: `block` }}
        >
          <div className="loading-box1">
            <div className="loading-spinner"></div>
          </div>
        </div>
      )}
      <iframe
        style={{ width: "100%", height: "270px" }}
        src={`https://fasthit.uk/wick-scorecard/?eventId=${object?.eventId}&marketId=${object?.marketId}&type=${object?.eventType}`}
      />
    </div>
  );
};

export default ShowHomeScoreboard;
